/* r27: `uppercaseQuotedText` lives in main.js, but createCartItemHTML needs it
   and THIS file runs first on a cold cache — every render then threw and the
   600ms retry poll spammed the console for seconds while the drawer stayed
   blank (worst right after a push, when main.js has a new ?v= to download and
   this file is still cached). Self-host it the same way formatShopifyPrice
   already is, guarded so main.js's copy wins if it got there first. */
window.uppercaseQuotedText=window.uppercaseQuotedText||function(str){return String(str).replace(/(['"])(.*?)\1/g,(match,quote,content)=>{return quote+content.toUpperCase()+quote})};
window.formatShopifyPrice=function(priceCents,currencyCode,locale=navigator.language){if(typeof priceCents!=='number'||isNaN(priceCents))return'';const price=priceCents/100;return new Intl.NumberFormat(locale,{style:'currency',currency:currencyCode,currencyDisplay:'symbol'}).format(price)};function cleanCartListeners(cartElement){const cart=typeof cartElement==='string'?document.querySelector(cartElement):cartElement;if(!cart){console.warn('Cart element not found for cleanup');return null}
const cleanCart=cart.cloneNode(!0);cart.parentNode.replaceChild(cleanCart,cart);return cleanCart}(function(){'use strict';if(window._cartUIInitialized)return;window._cartUIInitialized=!0;function debounce(func,wait){let timeout=null;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait)}}
class ShopifyCartUIGenerator{constructor(){this.cartContainer=document.getElementById('CART');this.stylesInjected=!1;this.lastCartHash=null;this.pendingUpdates=new Map();this.debouncedQuantityUpdate=debounce(this._executeQuantityUpdate.bind(this),300);this.bindEvents()}
bindEvents(){window.addEventListener('updateTopbarAndCart',(event)=>{console.log('updateTopbarAndCart event received',event.detail);this.generateCartUI()})}
_getCartHash(cart){if(!cart||!cart.items)return'';return cart.items.map(item=>`${item.id}:${item.quantity}:${item.final_line_price}`).join('|')+'|'+cart.total_price}
generateCartUI(){console.log('generateCartUI called');if(!this.cartContainer){console.warn('Cart container with ID "CART" not found');return}
const cart=window.shopifyData?.cart;console.log('Current cart data:',cart);if(!cart){console.warn('No cart data available in window.shopifyData');return}
const newHash=this._getCartHash(cart);if(newHash===this.lastCartHash){return}
/* Build the HTML BEFORE committing the hash: createCartHTML depends on helpers
   defined by main.js (uppercaseQuotedText, formatShopifyPrice). On a fresh page
   load with a non-empty cart this file's init() can run first; the old code
   stored lastCartHash and THEN threw mid-render, so every later event with the
   same cart was hash-skipped and the drawer stayed permanently blank. Now a
   failed render leaves the hash unset and retries until main.js is ready. */
let cartHTML;try{cartHTML=this.createCartHTML(cart)}catch(e){this._renderRetries=(this._renderRetries||0)+1;if(this._renderRetries>10){console.error('Cart render failed 10x, giving up:',e);return}
console.error('Cart render failed (helpers not ready yet?), retrying:',e);if(!this._renderRetryQueued){this._renderRetryQueued=!0;setTimeout(()=>{this._renderRetryQueued=!1;this.generateCartUI()},600)}return}
this._renderRetries=0;
const prevHash=this.lastCartHash;this.lastCartHash=newHash;const _hadAchieved=!!document.querySelector('.decoy-shipping-bar.achieved');/* HAPTICS */const oldScrollContainer=document.querySelector('.cart-items');const scrollTop=oldScrollContainer?.scrollTop||0;if(this.cartContainer.innerHTML!==cartHTML){this.cartContainer=cleanCartListeners('#CART');this.cartContainer.innerHTML=cartHTML;this.bindCartEvents();const newScrollContainer=document.querySelector('.cart-items');if(newScrollContainer){newScrollContainer.scrollTop=scrollTop}
/* P9: new/updated rows flash a 3px accent left bar (~500ms decay). Skipped on
   the session's first render (prevHash null) so page load never flashes. */
if(prevHash!==null&&cart.items){const prevQty={};prevHash.split('|').slice(0,-1).forEach(part=>{const bits=part.split(':');if(bits.length>=2){prevQty[bits[0]]=bits[1]}});cart.items.forEach((item,i)=>{if(prevQty[String(item.id)]!==String(item.quantity)){const rowEl=this.cartContainer.querySelector('.cart-item[data-line-item="'+(i+1)+'"]');if(rowEl){rowEl.classList.add('cart-item-flash');setTimeout(()=>{rowEl.classList.remove('cart-item-flash')},700)}}})}
if(!_hadAchieved&&document.querySelector('.decoy-shipping-bar.achieved')){window._haptics?.trigger('nudge')}/* HAPTICS */}}
createCartHTML(cart){if(!cart.items||cart.items.length===0){return this.createEmptyCartHTML()}
this._updateCartBadges(cart.item_count);return `
                <div class="cart-wrapper">
                    <div class="shopCartButton topbarButton cart-drawer-tab noselect" id="cart_drawer_tab" onclick="toggleCart()" aria-label="Close cart" style="position: absolute;top: 0;left: 0;z-index: 99999;">
                        <svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-shopping_cart"></use></svg>
                        <div class="cart_number"><span class="cartNumBubble">${cart.item_count}</span></div>
                    </div>

                    <div class="cart-header">
                        <h3 class="cart-title">CART ⁣‣ ${cart.item_count} ${cart.item_count === 1 ? 'ITEM' : 'ITEMS'}</h3>
                        <div class="cart-buttons-toprow">
                            <button onclick="window._haptics?.trigger('light');/* HAPTICS */window.open('https://decoy.ltd/customer_authentication/redirect', '_blank')" class="orders-btn">ORDERS</button>
                        </div>
                    </div>

                    <div class="cart-items-wrap">
                      <div class="cart-items">
                        ${cart.items.map((item, index) => this.createCartItemHTML(item, index)).join('')}
                        <div class="cart-clear-row">
                            <button class="cart-clear-trigger" data-cart-clear>CLEAR CART</button>
                            <div class="cart-clear-confirm">
                                <span class="cart-clear-q">CLEAR CART?</span>
                                <button class="cart-clear-yes" data-cart-clear-yes>YES</button>
                                <span class="cart-clear-sep">/</span>
                                <button class="cart-clear-no" data-cart-clear-no>NO</button>
                            </div>
                        </div>
                      </div>
                    </div>

                    <div class="cart-footer">
                        <div class="cart-summary">
                            <div class="summary-row">
                                <span class="summary-label">SUBTOTAL</span>
                                <span class="summary-value">${formatShopifyPrice(cart.total_price, shopifyData.cart.currency)}</span>
                            </div>
                            ${cart.total_discount > 0 ? `<div class="summary-row summary-discount"><span class="summary-label">DISCOUNT</span><span class="summary-value">-${formatShopifyPrice(cart.total_discount,shopifyData.cart.currency)}</span></div>` : ''}
                            <div class="summary-row summary-shipping">
                                <span class="summary-label">SHIPPING <span class="summary-note">// COST BASED ON LOCATION/ORDER SIZE</span></span>
                                <span class="summary-value">${(() => {
                                    /* US: $5-$10, FREE at the 2-item threshold. Rest of North
                                       America: same range converted. Outside NA: ~$25 converted.
                                       Shopify.currency.rate converts from the shop's USD base. */
                                    const country = window.Shopify?.country;
                                    const cur = shopifyData.cart.currency;
                                    const rate = parseFloat(window.Shopify?.currency?.rate || '1') || 1;
                                    const conv = (usd) => formatShopifyPrice(Math.round(usd * rate) * 100, cur).replace(/([.,]00)(?=\D*$)/, '');
                                    if (country === 'US' && cart.item_count >= 2) return 'FREE';
                                    const isNA = ['US', 'CA', 'MX'].includes(country || 'US');
                                    return isNA ? conv(5) + ' - ' + conv(10) : conv(25);
                                })()}</span>
                            </div>
                            <div class="summary-row">
                                <span class="summary-label">SHIPS BY</span>
                                <span class="summary-value">${(() => { const d = new Date(Date.now() + 48*60*60*1000); return d.toLocaleDateString('en-US', {month:'short', day:'2-digit'}).toUpperCase(); })()}</span>
                            </div>
                        </div>
                        ${(() => {
    const country = window.Shopify?.country;
    const isUS = country === 'US';
    const isUnknown = !country;
    const itemCount = cart.item_count || 0;
    const hasOne = itemCount >= 1;
    const hasTwo = itemCount >= 2;
    const achieved = hasTwo;

    let label;
    if (achieved) {
        label = isUS ? 'FREE SHIPPING + 10% OFF UNLOCKED' : '10% OFF UNLOCKED';
    } else if (hasOne) {
        label = isUS ? 'Add 1 more for FREE SHIPPING + 10% OFF' : 'Add 1 more for 10% OFF';
    } else {
        label = isUS ? 'Add 2 items for FREE SHIPPING + 10% OFF' : 'Add 2 items for 10% OFF';
    }
    if (isUnknown && isUS !== true) label += ' (US: +Free Shipping)';

    /* USER RIDER: the incentive bar sits in the footer, directly above
       CHECKOUT — it frames the next action, not the item list. */
    return `<div class="decoy-shipping-bar${achieved ? ' achieved' : ''}">
        <div class="shipping-bar__label">${label}</div>
        <div class="shipping-bar__tracks">
            <div class="shipping-bar__track${hasOne ? ' filled' : ''}"></div>
            <div class="shipping-bar__track${hasTwo ? ' filled' : ''}"></div>
        </div>
    </div>`;
})()}
                        <button class="cart-checkout-btn" onclick="window._haptics?.trigger('medium');/* HAPTICS */window.location.href='/checkout'">
                            Checkout
                        </button>
                    </div>
                </div>
                ${this.getCartStyles()}
            `}
createCartItemHTML(item,index){const lineNumber=index+1;const esc=(s)=>String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');const itemImage=(item.featured_image?.url||item.image||'')+'&width=200';const itemImageAlt=esc(item.featured_image?.alt||item.title||'');const _alloc=Array.isArray(item.line_level_discount_allocations)&&item.line_level_discount_allocations.length>0;const _disc=_alloc&&item.final_line_price<item.original_line_price;const priceBlock=_disc?`<p class="item-price-disc"><s>${formatShopifyPrice(item.original_line_price,shopifyData.cart.currency)}</s> <b>${formatShopifyPrice(item.final_line_price,shopifyData.cart.currency)}</b>${item.quantity===1?` <span class="deal-chip">50% OFF</span>`:''}</p>`:(item.quantity>1?`<p class="item-unit-price">${formatShopifyPrice(item.final_price,shopifyData.cart.currency)} EACH</p>`:'');return `
                <div class="cart-item" data-line-item="${lineNumber}" data-item-id="${item.id}">
                    <div class="cart-item-image">
                        ${itemImage
                            ? `<img src="${esc(itemImage)}" alt="${itemImageAlt}" loading="lazy">`
                            : '<div class="no-image">No Image</div>'}
                    </div>
                    <div class="cart-item-body">
                        <h4 class="item-title">${esc(uppercaseQuotedText(item.product_title))}</h4>
                        ${item.variant_title && item.variant_title !== 'Default Title'
                            ? `<p class="item-variant">${esc(item.variant_title)}</p>`
                            : ''}
                        ${priceBlock}
                        ${Object.keys(item.properties || {}).length > 0 ? `<div class="item-properties">${Object.entries(item.properties).map(([key,value])=>value?`<p class="property"><strong>${esc(key)}:</strong> ${esc(value)}</p>`:'').join('')}</div>` : ''}
                    </div>
                    <div class="cart-item-controls">
                        <div class="qty-stepper">
                            <button class="qty-step qty-plus" data-line-item="${lineNumber}" data-quantity="${item.quantity + 1}" aria-label="Increase quantity"><svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-keyboard_arrow_up"></use></svg></button>
                            <input type="number" class="quantity-input" value="${item.quantity}" min="0" max="999" data-line-item="${lineNumber}">
                            <button class="qty-step qty-minus" data-line-item="${lineNumber}" data-quantity="${item.quantity - 1}" aria-label="Decrease quantity"><svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-keyboard_arrow_down"></use></svg></button>
                        </div>
                        <span class="line-total">${formatShopifyPrice(item.final_line_price, shopifyData.cart.currency)}</span>
                        <button class="remove-item-btn" data-line-item="${lineNumber}" data-quantity="0"><svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-close"></use></svg></button>
                    </div>
                </div>
            `}
createEmptyCartHTML(){this._updateCartBadges(0);return `
                <div class="cart-wrapper">
                    <div class="shopCartButton topbarButton cart-drawer-tab noselect" id="cart_drawer_tab" onclick="toggleCart()" aria-label="Close cart" style="position: absolute;top: 0;left: 0;z-index: 99999;">
                        <svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-shopping_cart"></use></svg>
                        <div class="cart_number"></div>
                    </div>

                    <div class="cart-header">
                        <h3 class="cart-title">CART ⁣‣ 0 ITEMS</h3>
                        <div class="cart-buttons-toprow">
                            <button onclick="window._haptics?.trigger('light');/* HAPTICS */window.open('https://decoy.ltd/customer_authentication/redirect', '_blank')" class="orders-btn">ORDERS</button>
                        </div>
                    </div>
                    <div class="cart-items">
                        <div class="cart-empty">
                            <h3>YOUR CART IS EMPTY</h3>
                            <div class="cart-empty-mark"><svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-visibility_off"></use></svg></div>
                            <p class="cart-empty-line">NOTHING RECOVERED.</p>
                        </div>
                    </div>
                </div>
                ${this.getCartStyles()}
            `}
_updateCartBadges(count){const badges=document.querySelectorAll('.cart_number');for(const badge of badges){badge.innerHTML=count>0?`<span class="cartNumBubble">${count}</span>`:''}}
bindCartEvents(){if(!this.cartContainer)return;this.cartContainer.addEventListener('change',(e)=>{if(e.target.classList.contains('quantity-input')){const lineItem=e.target.dataset.lineItem;const quantity=parseInt(e.target.value)||0;this.queueQuantityUpdate(lineItem,quantity)}});this.cartContainer.addEventListener('click',(e)=>{const step=e.target.closest('.qty-step');if(step){window._haptics?.trigger('selection');/* HAPTICS */this.queueQuantityUpdate(step.dataset.lineItem,parseInt(step.dataset.quantity));return}
const removeBtn=e.target.closest('.remove-item-btn');if(removeBtn){window._haptics?.trigger('rigid');/* HAPTICS */this.updateCartItem(removeBtn.dataset.lineItem,0);return}
/* P6: CLEAR CART inline confirm — trigger swaps to "CLEAR CART? YES / NO" */
const clearTrigger=e.target.closest('[data-cart-clear]');if(clearTrigger){window._haptics?.trigger('light');/* HAPTICS */clearTrigger.closest('.cart-clear-row')?.classList.add('confirming');return}
if(e.target.closest('[data-cart-clear-yes]')){window._haptics?.trigger('heavy');/* HAPTICS */this.clearCart();return}
const clearNo=e.target.closest('[data-cart-clear-no]');if(clearNo){window._haptics?.trigger('light');/* HAPTICS */clearNo.closest('.cart-clear-row')?.classList.remove('confirming');return}
})}
queueQuantityUpdate(lineItem,quantity){this.pendingUpdates.set(lineItem,quantity);const itemEl=document.querySelector(`[data-line-item="${lineItem}"]`);if(itemEl){itemEl.classList.add('cartItemPending')}
/* Optimistic badge: show the target count immediately instead of waiting for the
   debounced network update. The cart response replaces the estimate; failures
   restore the last confirmed count. */
const _cart=window.shopifyData?.cart;if(_cart?.items){let _total=0;_cart.items.forEach((it,i)=>{const p=this.pendingUpdates.get(String(i+1));_total+=p!==undefined?Math.max(0,p):it.quantity});this._updateCartBadges(_total)}
this.debouncedQuantityUpdate()}
async _executeQuantityUpdate(){if(this.pendingUpdates.size===0)return;const updates=Array.from(this.pendingUpdates.entries());this.pendingUpdates.clear();for(const[lineItem,quantity]of updates){await this.updateCartItem(lineItem,quantity)}}
async updateCartItem(lineItem,quantity){const itemEl=document.querySelector(`[data-line-item="${lineItem}"]`);if(itemEl){itemEl.classList.add('cartItemPending')}
try{const response=await fetch('/cart/change.js?NREC=1',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({line:parseInt(lineItem),quantity})});const responseData=await response.json();if(response.ok){window.shopifyData.cart=responseData;window.dispatchEvent(new CustomEvent('updateTopbarAndCart',{detail:{cart:responseData}}))}else{let errorMessage='Failed to update cart item';if(responseData.message){errorMessage=responseData.message}else if(responseData.description){errorMessage=responseData.description}else if(responseData.error){errorMessage=responseData.error}
/* P8: non-blocking toast instead of alert(); affected row flashes its hairline */
(window.DECOY_TOAST||window.alert)(errorMessage);console.error('Shopify cart update error:',responseData);this._flashRowError(itemEl)}}catch(error){(window.DECOY_TOAST||window.alert)('Error updating cart item: '+error.message);console.error('Error updating cart item:',error);this._flashRowError(itemEl)}finally{if(itemEl){itemEl.classList.remove('cartItemPending')}
/* Optimistic-badge settle: once no updates are queued, the authoritative cart
   (fresh on success, unchanged on error) owns the badge again. */
if(this.pendingUpdates.size===0){this._updateCartBadges(window.shopifyData?.cart?.item_count||0)}}}
_flashRowError(itemEl){if(!itemEl||!itemEl.classList.contains('cart-item'))return;itemEl.classList.add('cart-error-flash');setTimeout(()=>{itemEl.classList.remove('cart-error-flash')},1700)}
async clearCart(){const itemEls=document.querySelectorAll('[data-line-item]');for(const itemEl of itemEls){itemEl.classList.add('cartItemPending')}
try{const response=await fetch('/cart/clear.js?NREC=1',{method:'POST'});if(response.ok){const clearedCart=await response.json();window.shopifyData.cart=clearedCart;window.dispatchEvent(new CustomEvent('updateTopbarAndCart',{detail:{cart:clearedCart}}))}else{console.error('Failed to clear cart')}}catch(error){console.error('Error clearing cart:',error)}}
getCartStyles(){if(this.stylesInjected){return''}this.stylesInjected=!0;if(!document.getElementById('decoy-cart-styles')){const s=document.createElement('style');s.id='decoy-cart-styles';s.textContent=`
/* ===== LV2 cart (P6-P10, P13) — vh for chrome, px for panel internals ===== */
.cart-wrapper {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}
.cart-items {
  flex: 1 !important;
  height: auto !important;
  min-height: 0 !important;
  overflow-y: auto !important;
}
/* ===== P6: header — CART left, ORDERS as quiet text link right ===== */
.cart-title {
  font-size: 1.9vh !important;
  font-weight: bold !important;
  letter-spacing: 0.05em !important;
  /* Lines CART up with the item thumbnails and SUBTOTAL (15px row padding +
     the 1px seam) in the desktop side panel. At max-width 1200px style.css's
     padding-left: 6.25vh !important still applies. */
  padding-left: 15px;
}
.cart-buttons-toprow {
  height: 100%;
  display: flex !important;
  align-items: center !important;
}
.cart-header .orders-btn {
  background: transparent !important;
  border: none !important;
  color: color-mix(in srgb, var(--AntiValue, #fff) 60%, transparent) !important;
  font-size: 1.4vh !important;
  letter-spacing: 0.08em !important;
  text-decoration: underline;
  text-underline-offset: 0.35vh;
  text-decoration-thickness: 1px;
  padding: 0 1.5vh !important;
  height: 100% !important;
  min-width: 44px;
  margin: 0 !important;
  cursor: pointer;
}
.cart-header .orders-btn:hover {
  color: var(--Highlight) !important;
  background: transparent !important;
}
/* ===== P6: item rows — ~96px, 64px thumb, horizontal stepper ===== */
.cart-item {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  min-height: 96px;
  padding: 12px 0 !important;
  border-bottom: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 14%, transparent) !important;
  box-sizing: border-box !important;
}
.cart-item-image {
  flex: 0 0 64px !important;
}
.cart-item-image img {
  width: 64px !important;
  height: 64px !important;
  -o-object-fit: cover !important;
  object-fit: cover !important;
  border: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 28%, transparent) !important;
  border-radius: 0 !important;
  box-sizing: border-box !important;
  display: block !important;
}
.cart-item-body {
  flex: 1 1 auto !important;
  min-width: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  gap: 0.5vh !important;
}
/* P13: uppercase titles via text-transform (data untouched) */
.item-title {
  margin: 0 !important;
  font-size: 1.9vh !important;
  line-height: 1.25 !important;
  font-weight: bold !important;
  text-transform: uppercase !important;
  color: var(--AntiValue, #fff) !important;
  display: -webkit-box !important;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden !important;
  white-space: normal !important;
}
/* The desktop drawer is 33vw, so the title column is ~140px — the longest catalog
   titles ("CORE1 \"STRESS\" EMBROIDERED DENIM HAT") need four lines there.
   Mobile keeps the tighter two-line clamp. */
@media (min-width: 1201px) {
  .item-title { -webkit-line-clamp: 4; }
}
.item-variant {
  margin: 0 !important;
  font-size: 1.4vh !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  opacity: 0.6;
}
.item-unit-price {
  margin: 0 !important;
  font-size: 1.4vh !important;
  letter-spacing: 0.05em;
  opacity: 0.55;
}
.cart-item-controls {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
  flex-shrink: 0 !important;
  margin-left: auto !important;
  padding-right: 0 !important;
}
/* Vertical quantity stepper: up chevron, the number, then the down chevron in a
   column (the number nested between the arrows). The chevrons are sized to read
   clearly, and each also grows its HIT AREA outward — the up arrow upward, the
   down arrow downward, both a little sideways — into the empty row space, so the
   arrows never overlap the number or each other. */
.qty-stepper {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 1px !important;
  flex-shrink: 0 !important;
}
.qty-step {
  position: relative !important;
  width: 34px !important;
  height: 22px !important;
  background: transparent !important;
  border: none !important;
  color: color-mix(in srgb, var(--AntiValue, #fff) 60%, transparent) !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  cursor: pointer !important;
  padding: 0 !important;
  border-radius: 0 !important;
  transition: color 0.15s !important;
}
.qty-step .decoy-icon { font-size: 2.4vh; pointer-events: none; }
/* Hit area grows outward (up arrow up, down arrow down, both sideways) into the
   empty row space around the narrow stepper — never onto the number between
   them. All pointers; touch gets a bit more side reach. */
.qty-step::before { content: ''; position: absolute; left: -6px; right: -6px; }
.qty-plus::before  { top: -12px; bottom: 0; }
.qty-minus::before { top: 0; bottom: -12px; }
@media (pointer: coarse) { .qty-step::before { left: -10px; right: -10px; } }
.qty-step:hover, .qty-step:active { color: var(--Highlight) !important; background: transparent !important; }
.quantity-input {
  width: 2.4ch !important;
  height: auto !important;
  background: transparent !important;
  border: none !important;
  color: var(--AntiValue, #fff) !important;
  text-align: center !important;
  font-size: 1.8vh !important;
  font-weight: bold !important;
  padding: 0 !important;
  -moz-appearance: textfield !important;
  line-height: 1 !important;
  border-radius: 0 !important;
  box-sizing: border-box !important;
}
.quantity-input::-webkit-outer-spin-button,
.quantity-input::-webkit-inner-spin-button { -webkit-appearance: none !important; }
/* P13: bare-bold price values */
.line-total {
  font-size: 1.8vh !important;
  font-weight: bold !important;
  white-space: nowrap !important;
  text-align: right !important;
  min-width: 6ch;
}
.remove-item-btn {
  width: 36px !important;
  height: 36px !important;
  border: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 28%, transparent) !important;
  background: transparent !important;
  color: color-mix(in srgb, var(--AntiValue, #fff) 45%, transparent) !important;
  cursor: pointer !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0 !important;
  flex-shrink: 0 !important;
  transition: border-color 0.2s, color 0.2s, background 0.2s !important;
  border-radius: 0 !important;
}
.remove-item-btn .decoy-icon {
  font-size: 2vh !important;
  pointer-events: none !important;
}
.remove-item-btn:hover {
  border-color: var(--Highlight) !important;
  color: var(--LumaCond) !important;
  background: var(--Highlight) !important;
}
/* ===== P6: CLEAR CART demoted below items with inline confirm ===== */
.cart-clear-row {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  padding: 0.4vh 0 0.8vh !important;
}
.cart-clear-trigger, .cart-clear-yes, .cart-clear-no {
  background: transparent !important;
  border: none !important;
  color: color-mix(in srgb, var(--AntiValue, #fff) 55%, transparent) !important;
  font-family: HelveticaNow, sans-serif !important;
  font-size: 1.4vh !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
  cursor: pointer !important;
  min-height: 44px !important;
  display: inline-flex !important;
  align-items: center !important;
  padding: 0 1vh !important;
  border-radius: 0 !important;
}
.cart-clear-trigger:hover {
  color: var(--Highlight) !important;
  text-decoration: underline;
  text-underline-offset: 0.3vh;
}
.cart-clear-confirm {
  display: none;
  align-items: center;
  color: color-mix(in srgb, var(--AntiValue, #fff) 55%, transparent);
  font-size: 1.4vh;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.cart-clear-row.confirming .cart-clear-trigger { display: none !important; }
.cart-clear-row.confirming .cart-clear-confirm { display: inline-flex !important; }
.cart-clear-yes { color: var(--Highlight) !important; font-weight: bold !important; }
.cart-clear-yes:hover { background: var(--Highlight) !important; color: var(--LumaCond) !important; }
.cart-clear-no:hover { color: var(--AntiValue, #fff) !important; }
/* ===== P6: footer — stacked summary rows + full-width 7vh accent CHECKOUT ===== */
/* r25 (user): no bottom padding — CHECKOUT is anchored to the drawer floor.
   The top padding is the divider→SUBTOTAL gap and is mirrored by
   .decoy-shipping-bar's bottom padding above CHECKOUT. */
.cart-footer {
  position: relative !important;
  bottom: auto !important;
  width: 100% !important;
  flex-shrink: 0 !important;
  /* 11px, not 14: the SUBTOTAL line carries 3px of leading above its cap
     height, so 11 puts the GLYPHS 14px under the divider — matching the 14px
     box gap the shipping bar leaves above CHECKOUT. Measured at 390x844. */
  padding: 11px 0 0 0 !important;
  box-sizing: border-box !important;
}
.cart-summary {
  display: block !important;
  padding: 0 0 1.2vh !important;
}
.summary-row {
  display: flex !important;
  justify-content: space-between !important;
  align-items: baseline !important;
  padding: 0.45vh 0 !important;
}
.summary-label {
  font-size: 1.5vh !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
  color: var(--AntiValue, #fff) !important;
  opacity: 0.65;
  font-weight: normal !important;
  white-space: nowrap !important;
}
/* Fine print inline after the SHIPPING label (own line looked like a stray
   gap between SHIPPING and SHIPS BY) */
.summary-note {
  font-size: 1.05vh !important;
  letter-spacing: 0.08em !important;
  text-transform: uppercase !important;
  color: var(--AntiValue, #fff) !important;
  opacity: 0.45;
  font-weight: normal !important;
  white-space: nowrap !important;
}
/* The note makes this label long — let it shrink instead of pushing the
   value, and never wrap under the price. */
.summary-shipping .summary-label {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  margin-right: 8px;
}
/* User r23: ONLY the subtotal line is enlarged. r18 bumped the shared
   .summary-* rules, which enlarged SHIPPING and SHIPS BY too. Subtotal is the
   FIRST .summary-row in .cart-summary; note that SHIPS BY is also a bare
   .summary-row, so class alone cannot separate them. */
.cart-summary .summary-row:first-child .summary-label { font-size: 2.4vh !important; }
.cart-summary .summary-row:first-child .summary-value { font-size: 3.2vh !important; }
.cart-summary .summary-row:first-child { padding: 0 0 0.6vh !important; }
.summary-value {
  font-size: 1.9vh !important;
  font-weight: bold !important;
  color: var(--AntiValue, #fff) !important;
  white-space: nowrap !important;
}
/* Discount: inverted highlight bar (user spec 2026-08-17) — white bar, black
   text on the dark theme; tracks --AntiValue/--MainValue so light mode stays
   legible. Deliberately NOT the accent color. */
.summary-discount {
  background: var(--AntiValue, #fff) !important;
  padding: 0.45vh 8px !important;
  margin: 0.3vh 0 !important;
}
.summary-discount .summary-label,
.summary-discount .summary-value {
  color: var(--MainValue, #000) !important;
  opacity: 1 !important;
}
.cart-checkout-btn {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  width: 100% !important;
  height: 7vh !important;
  background: var(--Highlight) !important;
  color: var(--LumaCond) !important;
  border: none !important;
  font-family: wideFont, HelveticaNow, sans-serif !important;
  font-size: 3vh !important;
  font-weight: normal !important;
  text-transform: uppercase !important;
  letter-spacing: 0.04em !important;
  cursor: pointer !important;
  padding: 0 !important;
  border-radius: 0 !important;
  transition: background-color 0.35s cubic-bezier(0,.54,0,1), color 0.35s cubic-bezier(0,.54,0,1) !important;
}
.cart-checkout-btn:hover {
  background: var(--LumaCond) !important;
  color: var(--Highlight) !important;
}
/* ===== CHECKOUT spans the full cart width =====
   Drop the drawer's horizontal padding and give the content rows their own side
   gutters instead, so the CHECKOUT button (which has none) reaches both edges. */
.cart-wrapper, #CART { padding-left: 0 !important; padding-right: 0 !important; }
.cart-item { padding: 12px 15px !important; }
.cart-clear-row { padding-left: 15px !important; padding-right: 15px !important; }
.decoy-shipping-bar { padding: 14px 15px !important; }
.cart-summary { padding-left: 15px !important; padding-right: 15px !important; }
/* ===== P7: shipping bar — docked under items; achieved = hazard stripes =====
   r25 (user): bottom padding equals .cart-footer's top padding so the gap
   above CHECKOUT matches the gap below the summary divider. */
.decoy-shipping-bar {
  width: 100%;
  padding: 14px 0;
  margin-bottom: 0;
  flex-shrink: 0 !important;
  box-sizing: border-box;
}
.shipping-bar__label {
  font-size: 13px !important;
  text-transform: uppercase !important;
  letter-spacing: 0.08em !important;
  margin-bottom: 10px !important;
  color: var(--AntiValue, #fff) !important;
  opacity: 1 !important;
  text-align: center !important;
  font-weight: normal !important;
}
.shipping-bar__tracks {
  display: flex;
  gap: 8px;
}
.shipping-bar__track {
  flex: 1;
  height: 28px;
  border: 2px solid var(--AntiValue, #fff);
  background: transparent;
  box-sizing: border-box;
  border-radius: 0;
  padding: 4px;
}
.shipping-bar__track::after {
  content: '';
  display: block;
  width: 100%;
  height: 100%;
  background: transparent;
  transition: background-color 0.4s ease, box-shadow 0.4s ease;
}
.shipping-bar__track.filled::after {
  background-color: var(--Highlight);
}
/* Achieved: rainbow flashing glow (restored 2026-08-17 per user; replaced the
   round-3 hazard barberpole). Off-palette hues are deliberate here — the
   threshold moment is the one place the palette breaks. */
.decoy-shipping-bar.achieved .shipping-bar__label {
  opacity: 1;
  font-weight: bold !important;
  animation: neon-text 3s linear infinite;
}
.decoy-shipping-bar.achieved .shipping-bar__track.filled::after {
  animation: neon-fill 3s linear infinite;
}
@keyframes neon-fill {
  0%   { background-color: #00ff41; box-shadow: 0 0 6px #00ff41; }
  16%  { background-color: #00ffff; box-shadow: 0 0 6px #00ffff; }
  33%  { background-color: #0080ff; box-shadow: 0 0 6px #0080ff; }
  50%  { background-color: #bf00ff; box-shadow: 0 0 6px #bf00ff; }
  66%  { background-color: #ff00bf; box-shadow: 0 0 6px #ff00bf; }
  83%  { background-color: #ff8000; box-shadow: 0 0 6px #ff8000; }
  100% { background-color: #00ff41; box-shadow: 0 0 6px #00ff41; }
}
@keyframes neon-text {
  0%   { color: #00ff41; text-shadow: 0 0 6px #00ff41; }
  16%  { color: #00ffff; text-shadow: 0 0 6px #00ffff; }
  33%  { color: #0080ff; text-shadow: 0 0 6px #0080ff; }
  50%  { color: #bf00ff; text-shadow: 0 0 6px #bf00ff; }
  66%  { color: #ff00bf; text-shadow: 0 0 6px #ff00bf; }
  83%  { color: #ff8000; text-shadow: 0 0 6px #ff8000; }
  100% { color: #00ff41; text-shadow: 0 0 6px #00ff41; }
}
/* ===== P9: add/update row flash — 3px accent left bar, ~500ms decay ===== */
@keyframes cart-row-flash {
  from { box-shadow: inset 3px 0 0 0 var(--Highlight); }
  to   { box-shadow: inset 3px 0 0 0 transparent; }
}
.cart-item.cart-item-flash { animation: cart-row-flash 0.5s ease-out 1 forwards; }
/* ===== P8: error — affected row flashes its hairline. box-shadow, NOT
   border-bottom-color: the row's border-bottom carries !important, and
   important author declarations outrank animation declarations, so a
   border keyframe would be silently inert ===== */
@keyframes cart-hairline-flash {
  0%, 100% { box-shadow: inset 0 0 0 0 transparent; }
  30%, 70% { box-shadow: inset 0 -2px 0 0 var(--Highlight); }
}
.cart-item.cart-error-flash { animation: cart-hairline-flash 0.8s linear 2; }
/* ===== P8: DECOY_TOAST — black, hazard-stripe left edge, condensed caps ===== */
#DECOY_TOASTS {
  position: fixed;
  top: calc(5vh + 10px);
  right: 10px;
  z-index: 2000; /* #FRONTEND (holds #CART) is z-1000; toasts sit above it */
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
  max-width: min(420px, calc(100vw - 20px));
}
.decoy-toast {
  pointer-events: auto;
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--MainValue, #000);
  color: var(--AntiValue, #fff);
  border: 1px solid var(--AntiValue, #fff);
  padding: 1.2vh 0.6vh 1.2vh calc(8px + 1.4vh);
  font-family: HelveticaNow, sans-serif;
  font-size: 1.5vh;
  line-height: 1.4;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  animation: decoy-toast-in 0.25s cubic-bezier(0,.54,0,1);
}
.decoy-toast::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 8px;
  background-color: var(--Highlight);
  background-image: var(--LightDiagonal);
  background-size: 7px 7px;
  background-repeat: repeat;
  -webkit-animation: barberpole 0.25s linear infinite;
  animation: barberpole 0.25s linear infinite;
}
.decoy-toast-close {
  background: transparent;
  border: none;
  color: color-mix(in srgb, var(--AntiValue, #fff) 60%, transparent);
  cursor: pointer;
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-radius: 0;
}
.decoy-toast-close .decoy-icon { font-size: 2vh; pointer-events: none; }
.decoy-toast-close:hover { color: var(--Highlight); }
.decoy-toast-out {
  opacity: 0;
  transform: translateY(-6px);
  transition: opacity 0.2s, transform 0.2s;
}
@keyframes decoy-toast-in {
  from { opacity: 0; transform: translateY(-8px); }
  to   { opacity: 1; transform: translateY(0); }
}
/* ===== P10: empty state — centered mark, no exits (footer hides when empty) ===== */
.cart-empty {
  text-align: center !important;
  min-height: 40vh !important;
  padding: 6vh 20px !important;
  color: color-mix(in srgb, var(--AntiValue, #fff) 60%, transparent) !important;
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 0 !important;
}
.cart-empty h3 {
  margin: 0 0 3vh !important;
  color: var(--AntiValue, #fff) !important;
  font-size: 2.2vh !important;
  letter-spacing: 0.06em !important;
}
.cart-empty-mark { opacity: 0.35; }
.cart-empty-mark .decoy-icon { font-size: 7vh; }
.cart-empty-line {
  margin: 2vh 0 0 !important;
  font-size: 1.6vh !important;
  letter-spacing: 0.14em !important;
  text-transform: uppercase !important;
  opacity: 0.6;
}
/* ===== full-bleed drawer range: stock strips .cart-wrapper padding at
   ≤1200px, so the gutters must come back for the whole range, not just
   phones ===== */
@media (max-width: 1200px) {
  .cart-item { padding: 12px 15px !important; }
  .cart-clear-row { padding-right: 15px !important; padding-left: 15px !important; }
  .decoy-shipping-bar { padding: 14px 15px; }
  .cart-summary { padding-left: 15px !important; padding-right: 15px !important; }
}
/* ===== phones: the SAME single-line row as the desktop drawer =====
   r25 (user): the old ≤480px rule dropped the controls onto their own line.
   They are inline again — but a 390px row only leaves the title 70px next to
   a 64px thumb and 210px of controls, so the title column is bought back:
   smaller thumb, tighter gaps, smaller line total. That lands the title at
   ~93px, where a four-line clamp holds every catalog name without an
   ellipsis (the row's 96px min-height already has the room). */
@media (max-width: 480px) {
  .cart-item { gap: 6px !important; }
  .cart-item-image { flex: 0 0 56px !important; }
  .cart-item-image img { width: 56px !important; height: 56px !important; }
  .cart-item-controls { gap: 6px !important; }
  .item-title { font-size: 1.6vh !important; -webkit-line-clamp: 4; }
  .line-total { font-size: 1.6vh !important; }
}
.cart-footer { border-top: 1px solid color-mix(in srgb, var(--AntiValue, #fff) 28%, transparent) !important; }
.cart-items-wrap { position: relative !important; flex: 1 1 auto !important; min-height: 0 !important; display: flex !important; flex-direction: column !important; }
.cart-items-wrap > .cart-items { flex: 1 1 auto !important; min-height: 0 !important; }
.deal-chip { background: var(--Highlight); color: var(--LumaCond); font-weight: bold; letter-spacing: 0.05em; font-size: 1.15vh; padding: 0.15vh 0.55vh; line-height: 1.5; white-space: nowrap; text-transform: uppercase; }
.item-price-disc { display: flex; gap: 0.6vh; align-items: baseline; flex-wrap: wrap; margin: 0 !important; font-size: 1.4vh !important; letter-spacing: 0.05em; }
.item-price-disc s { opacity: 0.5; }
.item-price-disc b { font-weight: bold; }
`;document.head.appendChild(s)}return''}}

/* ===== P8: DECOY_TOAST — non-blocking hazard-edged toast (replaces alert()).
   Fixed under the topbar / cart drawer header (both 5vh); stacks max 2;
   4s auto-dismiss + close button. Mount node is created lazily from JS. */
window.DECOY_TOAST=function(message,opts){opts=opts||{};if(!document.getElementById('decoy-cart-styles')&&window._cartUIInstance){window._cartUIInstance.getCartStyles()}
let wrap=document.getElementById('DECOY_TOASTS');if(!wrap){wrap=document.createElement('div');wrap.id='DECOY_TOASTS';document.body.appendChild(wrap)}
while(wrap.children.length>=2){wrap.removeChild(wrap.firstChild)}
const toast=document.createElement('div');toast.className='decoy-toast';const msg=document.createElement('span');msg.className='decoy-toast-msg';msg.textContent=String(message);const close=document.createElement('button');close.className='decoy-toast-close';close.setAttribute('aria-label','Dismiss');close.innerHTML='<svg class="decoy-icon" aria-hidden="true" focusable="false"><use href="#i-close"></use></svg>';toast.appendChild(msg);toast.appendChild(close);wrap.appendChild(toast);let gone=!1;const dismiss=()=>{if(gone)return;gone=!0;toast.classList.add('decoy-toast-out');setTimeout(()=>{toast.remove()},220)};close.addEventListener('click',()=>{window._haptics?.trigger('light');/* HAPTICS */dismiss()});setTimeout(dismiss,opts.duration||4000);return toast};
function init(){if(window._cartUIInstance)return;console.log('Initializing ShopifyCartUIGenerator');window._cartUIInstance=new ShopifyCartUIGenerator();if(window.shopifyData?.cart){console.log('Initial cart data found, generating UI');window._cartUIInstance.generateCartUI()}}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}})()